export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9860.9ed0c1b4.jpg";